// This prevents iOS zoom on focused form elements with font size smaller than 16px.
// iOS 10+ allows pinch-zoom even if viewport is unscalaeable.
// We feature detect those browsers and apply additional rules.
if (
    window.CSS?.supports?.(
        '(font:-apple-system-body) and (-webkit-touch-callout:none) and (-webkit-tap-highlight-color:hotpink)'
    )
) {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport !== null) {
        viewport.content = `${viewport.content},user-scalable=no`;
    }
}

/**
 * Klaviyo Subscribe Utility
 * https://github.com/estrattonbailey/klaviyo-subscribe
 */
async function subscribe(e,t,n){void 0===n&&(n={});var s=Object.assign({},n,{g:e,email:t}),r=Object.keys(s).reduce(function(e,t){return e.append(t,s[t]),e},new URLSearchParams);const e_2 = await fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", { method: "POST", headers: { "Access-Control-Allow-Headers": "*", "Content-Type": "application/x-www-form-urlencoded; charset=utf-8" }, body: r });
return await e_2.json();};

var validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// KLAVIYO SUBMIT FUNCTIONALITY
function handleSubmit(listId, obj, email, formSelector, redirectUrl) {
	formSelector.querySelector(".klaviyo_messages").innerHTML = "";
	console.log(listId);
	if (email.length > 1 && email.match(validEmailRegex)) {
		if (listId !== 123456) {
			subscribe(listId, email, obj).then(response => {
				if (response.success) {

					if(formSelector.querySelector(`[type="tel"]`) !== null && formSelector.querySelector(`[type="tel"]`).value.length){

						const requestOptions = {
							method: "GET", 
							redirect: "follow"
						};

						let smsUrl = `https://otm-shop.netlify.app/.netlify/functions/sms-consent?list_id=${listId}&email=${email}&phone=${formSelector.querySelector(`[type="tel"]`).value}&source=${encodeURIComponent(formSelector.querySelector(`[name="$source"]`).value)}&marketing=true`;
						
						console.log(smsUrl)
						  
						fetch(smsUrl, requestOptions)
						.then((response) => response.text())
						.then((result) => console.log(result))
						.catch((error) => console.error(error));

					}	


					formSelector.querySelector(".klaviyo_messages").style.display = "none";
					if (redirectUrl.length) {
						window.location.replace(redirectUrl);
					} else {
						formSelector.querySelector(".klaviyo_success").style.display = "block";
					}
					formSelector.querySelectorAll(".form__input").forEach($i => {
						$i.value = "";
					});
					formSelector.classList.add("success");
				} else {
					formSelector.querySelector(".klaviyo_success").style.display = "none";
					formSelector.querySelector(".klaviyo_messages").style.display = "block";
					response.errors.forEach(function(error) {
						let klaviyoHTML = document.createRange().createContextualFragment(`<div>${error}</div>`);
						formSelector.querySelector(".klaviyo_messages").append(klaviyoHTML);
					});
				}
			});
		} else {
			formSelector.querySelector(".klaviyo_messages").style.display = "block";
			let klaviyoHTML = document.createRange().createContextualFragment(`<div>Please use a valid Klaviyo ID.</div>`);
			formSelector.querySelector(".klaviyo_messages").append(klaviyoHTML);
		}
	} else {
		formSelector.querySelector(".klaviyo_messages").style.display = "block";
		let klaviyoHTML = document.createRange().createContextualFragment(`<div>Invalid Email</div>`);
		formSelector.querySelector(".klaviyo_messages").append(klaviyoHTML);
	}
}
if (document.querySelector(".klaviyo-newsletter") !== null) {
	document.querySelectorAll(".klaviyo-newsletter").forEach($form => {

		// FORM INPUT CHANGE
		const $klaviyoEmail = $form.querySelector(".form__input")
		const handleEmailInput = () => {
			const val = $klaviyoEmail.value;
			if (val.length > 1 && val.match(validEmailRegex)) {
				$form.querySelector(".klaviyo_messages").innerHTML = "";
				$form.querySelector(".klaviyo_messages").style.display = "none";
			} 
		}
		$klaviyoEmail.addEventListener("change", handleEmailInput, false);
		$klaviyoEmail.addEventListener("input", handleEmailInput, false);
		$klaviyoEmail.addEventListener("focus", handleEmailInput, false);

		// FORM SUBMISSION
		const $submit = $form.querySelector("[type='submit']");
		const $email = $form.querySelector("[type='email']");
		const listId = $form.querySelector("[name='g']").value;
		let fieldsArr = [];
		let fieldsObj = {};
		let klaviyoObj = {};
		$form.addEventListener("submit", function(e) {
			e.preventDefault();
			console.log("---------Submitting form-----------");
			fieldsArr = ["Accepts Marketing"];
			fieldsObj = {};
			klaviyoObj = {};
			$form.querySelectorAll("input").forEach($i => {
				if ($i.type !== "submit" && $i.type !== "hidden" && $i.type !== "email" && $i.name !== "$first_name" && $i.name !== "$last_name") {
					fieldsArr.push($i.name);
					fieldsObj[$i.name] = $i.value;
				}
				if($i.name === "$source"){
					fieldsArr.push("$source");
					fieldsObj["$source"] = $i.value;
				}				
			});
			$form.querySelectorAll("textarea").forEach($t => {
				fieldsArr.push($t.name);
				fieldsObj[$t.name] = $t.value;
			});
			$form.querySelectorAll("select").forEach($s => {
				fieldsArr.push($s.name);
				fieldsObj[$s.name] = $s.value;
			});
			if ($form.querySelector("[name='$first_name']") !== null) {
				fieldsObj["$first_name"] = $form.querySelector("[name='$first_name']").value;
			}
			if ($form.querySelector("[name='$last_name']") !== null) {
				fieldsObj["$last_name"] = $form.querySelector("[name='$last_name']").value;
			}
			fieldsObj["Accepts Marketing"] = true;
			klaviyoObj = { ...{
					$fields: fieldsArr
				},
				...fieldsObj
			};
			// console.log(klaviyoObj)
			handleSubmit(listId, klaviyoObj, $email.value, $form, "");
		});
		$submit.addEventListener("click", e => {
			e.preventDefault();
			console.log("---------Submitting form-----------");
			fieldsArr = ["Accepts Marketing"];
			fieldsObj = {};
			klaviyoObj = {};
			$form.querySelectorAll("input").forEach($i => {
				if ($i.type !== "submit" && $i.type !== "hidden" && $i.type !== "email" && $i.name !== "$consent" && $i.name !== "$first_name" && $i.name !== "$last_name") {
					fieldsArr.push($i.name);
					fieldsObj[$i.name] = $i.value;
				}
				if($i.name === "$source"){
					fieldsArr.push("$source");
					fieldsObj["$source"] = $i.value;
				}
			});
			$form.querySelectorAll("textarea").forEach($t => {
				fieldsArr.push($t.name);
				fieldsObj[$t.name] = $t.value;
			});
			$form.querySelectorAll("select").forEach($s => {
				fieldsArr.push($s.name);
				fieldsObj[$s.name] = $s.value;
			});
			if ($form.querySelector("[name='$first_name']") !== null) {
				fieldsObj["$first_name"] = $form.querySelector("[name='$first_name']").value;
			}
			if ($form.querySelector("[name='$last_name']") !== null) {
				fieldsObj["$last_name"] = $form.querySelector("[name='$last_name']").value;
			}
			fieldsObj["Accepts Marketing"] = true;
			klaviyoObj = { ...{
					$fields: fieldsArr
				},
				...fieldsObj
			};
			// console.log(klaviyoObj)
			handleSubmit(listId, klaviyoObj, $email.value, $form, "");
		});
	});
}

// COOKIES
function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function deleteCookie(name) { setCookie(name, '', -1); }

// deleteCookie("klaviyo-popup")

const klaviyoCookie = getCookie("klaviyo-popup");

if (klaviyoCookie == null) {
	setTimeout(() => {
		setCookie("klaviyo-popup", "activated", 2);
		document.getElementById("klaviyo-popup").classList.add("active");
		setTimeout(() => {
			document.querySelector("#klaviyo-popup .klaviyo-popup--close").focus();
			window.trapFocus.trap(document.getElementById("klaviyo-popup"));
		}, 150);
	}, 2000)
}